import {ValueObject} from '@s-ui/domain'

export class SubscriptionSearchRequestValueObject extends ValueObject {
  /**
   * @constructor
   * @param {Object} params
   * @param {Object} params.filters
   * @param {Array<Object>} params.filters.price
   * @param {Array<Object>} params.filters.vehicles
   * @param {Object} params.pagination
   * @param {Number} params.pagination.page
   * @param {Number} params.pagination.size
   * @param {Object} params.sort
   * @param {String} params.sort.order
   * @param {String} params.sort.term
   */

  static validate({filters, pagination, sort, getSubscriptionSearchResultsInvalidRequestAdsErrorFactory}) {
    if (!pagination || !pagination.hasOwnProperty('page') || !pagination.hasOwnProperty('size')) {
      throw getSubscriptionSearchResultsInvalidRequestAdsErrorFactory()
    }
  }
}
